import { useCallback, useEffect, useState } from 'react';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import { apiurl } from '../../utils/constants';

// iden debiese ser el entry de la SM
export function ListSmDeta({ onMenuItemClick, iden, typeDocu }) {
    const { mail, sapDB } = useSelector((state) => state.user);
    const [SMData, setSMData] = useState([]);
    const [smLines, setSmLines] = useState([]);
    const [loadingAttachment, setLoadingAttachment] = useState(false);
	const currentUrl = window.location.href;

    const fetchSalidaMercanciaLines = useCallback(async () => {
        if (!SMData?.docu) return;

        try {
            const response = await fetch(apiurl + 'sm/inventoryGenExit/linesByDocNum', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({
                    sapDB,
                    user: mail,
                    docNum: SMData.docu,
                }),
            });

            if (response.ok) {
                const r = await response.json();
                setSmLines(Array.isArray(r.lines) ? r.lines : []);
            } else {
                setSmLines([]);
            }
        } catch (error) {
            console.error('Error:', error);
            setSmLines([]);
            return null;
        }
    }, [sapDB, mail, SMData]);

    const fetchSalidaMercancia = useCallback(async () => {
        try {
            const response = await fetch(apiurl + 'queryAux', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({
                    user: mail,
                    query: `SELECT re.*, su.name as sender_name, rs.requested soli_requested
							FROM  req__exit re
                            left join sys__user su on su.iden = re.sender
                            join req__soli  rs on rs.iden = re.soli
							WHERE re.entry = ${iden}`,
                }),
            });

            if (response.ok) {
                const data = await response.json();
                setSMData(data[0]);
            }
        } catch (error) {
            console.error('Error:', error);
            return null;
        }
    }, [mail, iden])

    useEffect(() => {
        fetchSalidaMercancia();
    }, [fetchSalidaMercancia])

    useEffect(() => {
        fetchSalidaMercanciaLines()
    }, [fetchSalidaMercanciaLines])


	const fCurr = useCallback((value) => {
		return new Intl.NumberFormat('es-CL', {
			currency: 'CLP',
		}).format(value);
	}, []);

    const handleGuiaDespacho = useCallback(async () => {
        setLoadingAttachment(true);
        try {
            const response = await fetch(apiurl + 'sm/attachment', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ sapDB, user: mail, docEntry: iden }),
            });
            const blob = await response.blob();
            window.open(URL.createObjectURL(blob), '_blank');
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoadingAttachment(false);
        }
    }, [sapDB, mail, iden]);

    return (
        <>
            <form>
                <style jsx="true">{`
				.itemTable .ellipsis{
					max-width: 500px;
				}
				.itemTable td:where(:last-child, :nth-child(3)){
					text-align: right;
				}
			`}</style>

                <main>
                    <h1 className={SMData.stat === 'O' ? 'red' : 'gre'} data-icon=''>
                        <span>Salida de mercancía <span>{SMData.docu}</span></span>
                        <mark >{SMData.stat === 'O' ? 'Abierta' : 'Cerrada'}</mark>
                    </h1>
                    <nav>

                        <section>
                            <h2><div>Enviado</div><div>{SMData.sent ? format(new Date(SMData.sent), 'dd/MM/yyyy') : ''}</div></h2>
                            {
                                <>
                                    <fieldset>
                                        <legend>Emisor</legend>
                                        <span>{SMData.sender_name}</span>
                                    </fieldset>
                                    <fieldset>
                                        <legend>Notificación</legend>
                                        {/*
                                        <span>{dataBD?.[0]?.sent_supp ? (dataBD?.[0]?.sent_error ?? `Enviado al proveedor el ${dataBD?.[0]?.sent_supp}`) : `Pendiente de autorización o envio`}</span>
                                        */}
                                        <span>Pendiente de autorización o envio</span>
                                    </fieldset>
                                </>
                            }
                        </section>
                        <section>
                            <h2><div>Actualizado</div><div>{SMData.updated ? format(new Date(SMData.updated), 'dd/MM/yyyy') : ''}</div></h2>
                            {
                                <fieldset>
                                    <legend>Comentario</legend>
                                    <span>{SMData.comm}</span>
                                </fieldset>
                            }
                        </section>
                        <section>
							<h2><div>Solicitud de compra</div><div></div></h2>
                            {
                                <fieldset>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>SC {SMData.soli}</td>
                                                {
                                                    <td>{SMData.soli_requested ? format(new Date(SMData.soli_requested), 'dd/MM/yyyy') : ''}</td>
                                                }
                                                <td><a href={currentUrl} onClick={(e) => {
                                                        e.preventDefault();
                                                        onMenuItemClick('listSolpDeta', SMData.soli);
                                                }}><figure></figure></a></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </fieldset>
                            }
                        </section>

                        <article className='scrollx'>
                            {
                                Array.isArray(smLines) && smLines.length === 0 ?
                                    (<p>No hay artículos.</p>) :
                                    (<table className='itemTable'>
                                        <thead>
                                            <tr>
                                                <td>Código</td>
                                                <td className='ellipsis'>Descripción</td>
                                                <td>Precio</td>
                                                <td>Cantidad</td>
                                                <td>Almacén</td>
                                                <td>Costo</td>
                                                <td>Activo fijo</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                smLines.map(item => (
                                                    <tr key={item.ItemCode}>
                                                        <td>{item.ItemCode}</td>
                                                        <td className='ellipsis'>{item.ItemDescription}</td>
                                                        <td>{fCurr(item.UnitPrice)} CLP</td>
                                                        <td>{item.Quantity} {item.Unit}</td>
                                                        <td>{item.WarehouseCode}</td>
                                                        <td>{fCurr(item.Cost)} CLP</td>
                                                        <td>{item.U_ActivoFijo}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>)
                            }
                        </article>
                        <h2>
                            <div></div>
                            <div>{fCurr(smLines.reduce((acc, item) => acc + item.UnitPrice * item.Quantity, 0))} CLP</div>
                        </h2>
                    </nav>
                </main>
                <aside>
                    <article>
                        <h2>Acciones</h2>
                        <fieldset>
                            <input type="button"
                                onClick={() =>
                                    onMenuItemClick('listSolpDeta', SMData.soli, SMData.soli)
                                }
                                value={'Volver a solped'} />
                        </fieldset>
                        <fieldset>
                            <input type="button"
                                onClick={handleGuiaDespacho}
                                disabled={loadingAttachment}
                                value={'Guía de despacho'} />
                        </fieldset>
                    </article>
                </aside>
            </form>
        </>
    );
}